import React, { useRef, useEffect } from 'react';

export default function VRView(props) {
  if (!props.url) return null;
  return (
    <div style={{ width: '100%', height: '100%', zIndex: 99 }}>
      <iframe
        src={props.url}
        allowFullScreen
        style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}>
      </iframe>
    </div>
  );
}